import { render } from "./ViewAssets.vue?vue&type=template&id=569feeec"
import script from "./ViewAssets.vue?vue&type=script&lang=js"
export * from "./ViewAssets.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__